import piece5mmk_01 from "../../../../assets/images/Event-2025/Piece/icon-piece-5mmk-01.png";
import piece5mmk_02 from "../../../../assets/images/Event-2025/Piece/icon-piece-5mmk-02.png";
import piece5mmk_03 from "../../../../assets/images/Event-2025/Piece/icon-piece-5mmk-03.png";
import piece5mmk_04 from "../../../../assets/images/Event-2025/Piece/icon-piece-5mmk-04.png";

import piece10mmk_01 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-01.png";
import piece10mmk_02 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-02.png";
import piece10mmk_03 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-03.png";
import piece10mmk_04 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-04.png";
import piece10mmk_05 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-05.png";
import piece10mmk_06 from "../../../../assets/images/Event-2025/Piece/icon-piece-10mmk-06.png";

import piece20mmk_01 from "../../../../assets/images/Event-2025/Piece/icon-piece-20mmk-01.png";
import piece20mmk_02 from "../../../../assets/images/Event-2025/Piece/icon-piece-20mmk-02.png";
import piece20mmk_03 from "../../../../assets/images/Event-2025/Piece/icon-piece-20mmk-03.png";

import piece50mmk_01 from "../../../../assets/images/Event-2025/Piece/icon-piece-50mmk_01.png";

import pieceTaiphone01 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-01.png";
import pieceTaiphone02 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-02.png";
import pieceTaiphone03 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-03.png";
import pieceTaiphone04 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-04.png";
import pieceTaiphone05 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-05.png";
import pieceTaiphone06 from "../../../../assets/images/Event-2025/Piece/icon-piece-taiphone-06.png";

import pieceLoa01 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-01.png";
import pieceLoa02 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-02.png";
import pieceLoa03 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-03.png";
import pieceLoa04 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-04.png";
import pieceLoa05 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-05.png";
import pieceLoa06 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-06.png";
import pieceLoa07 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-07.png";
import pieceLoa08 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-08.png";
import pieceLoa09 from "../../../../assets/images/Event-2025/Piece/icon-piece-loa-09.png";

import pieceSmartWatch01 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-01.png";
import pieceSmartWatch02 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-02.png";
import pieceSmartWatch03 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-03.png";
import pieceSmartWatch04 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-04.png";
import pieceSmartWatch05 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-05.png";
import pieceSmartWatch06 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-06.png";
import pieceSmartWatch07 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-07.png";
import pieceSmartWatch08 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-08.png";
import pieceSmartWatch09 from "../../../../assets/images/Event-2025/Piece/icon-piece-smart-watch-09.png";

import pieceIpad01 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-01.png";
import pieceIpad02 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-02.png";
import pieceIpad03 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-03.png";
import pieceIpad04 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-04.png";
import pieceIpad05 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-05.png";
import pieceIpad06 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-06.png";
import pieceIpad07 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-07.png";
import pieceIpad08 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-08.png";
import pieceIpad09 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-09.png";
import pieceIpad10 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-10.png";
import pieceIpad11 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-11.png";
import pieceIpad12 from "../../../../assets/images/Event-2025/Piece/icon-piece-ipad-12.png";

import prize8 from "../../../../assets/images/Event-2025/prize-1.png";
import prize7 from "../../../../assets/images/Event-2025/prize-2.png";
import prize6 from "../../../../assets/images/Event-2025/prize-3.png";
import prize5 from "../../../../assets/images/Event-2025/prize-4.png";
import prize4 from "../../../../assets/images/Event-2025/prize-5.png";
import prize3 from "../../../../assets/images/Event-2025/prize-6.png";
import prize2 from "../../../../assets/images/Event-2025/prize-7.png";
import prize1 from "../../../../assets/images/Event-2025/prize-8.png";

import surface1 from "../../../../assets/images/Event-2025/surface-1.png";
import surface2 from "../../../../assets/images/Event-2025/surface-2.png";
import surface3 from "../../../../assets/images/Event-2025/surface-3.png";
import surface4 from "../../../../assets/images/Event-2025/surface-4.png";
import surface5 from "../../../../assets/images/Event-2025/surface-5.png";
import surface6 from "../../../../assets/images/Event-2025/surface-6.png";
import surface7 from "../../../../assets/images/Event-2025/surface-7.png";
import surface8 from "../../../../assets/images/Event-2025/popup-surface.png";

import collect1_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece1-1.png";
import collect1_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece1-2.png";
import collect1_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece1-3.png";
import collect1_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece1-4.png";
import collect1_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece1-5.png";
import collect1_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece1-6.png";

import collect_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece-1.png";
import collect_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece-2.png";
import collect_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece-3.png";
import collect_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece-4.png";

import collect2_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece2-1.png";
import collect2_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece2-2.png";
import collect2_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece2-3.png";
import collect2_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece2-4.png";
import collect2_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece2-5.png";
import collect2_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece2-6.png";

import collect3_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece3-1.png";
import collect3_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece3-2.png";
import collect3_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece3-3.png";
import collect3_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece3-4.png";
import collect3_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece3-5.png";
import collect3_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece3-6.png";

import collect4_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece4-1.png";
import collect4_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece4-2.png";
import collect4_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece4-3.png";
import collect4_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece4-4.png";
import collect4_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece4-5.png";
import collect4_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece4-6.png";

import collect5_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece5-1.png";
import collect5_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece5-2.png";
import collect5_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece5-3.png";
import collect5_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece5-4.png";
import collect5_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece5-5.png";
import collect5_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece5-6.png";
import collect5_prize07 from "../../../../assets/images/Event-2025/Piece/icon-piece5-7.png";
import collect5_prize08 from "../../../../assets/images/Event-2025/Piece/icon-piece5-8.png";
import collect5_prize09 from "../../../../assets/images/Event-2025/Piece/icon-piece5-9.png";

import collect6_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece6-1.png";
import collect6_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece6-2.png";
import collect6_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece6-3.png";
import collect6_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece6-4.png";
import collect6_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece6-5.png";
import collect6_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece6-6.png";
import collect6_prize07 from "../../../../assets/images/Event-2025/Piece/icon-piece6-7.png";
import collect6_prize08 from "../../../../assets/images/Event-2025/Piece/icon-piece6-8.png";
import collect6_prize09 from "../../../../assets/images/Event-2025/Piece/icon-piece6-9.png";

import collect7_prize01 from "../../../../assets/images/Event-2025/Piece/icon-piece7-1.png";
import collect7_prize02 from "../../../../assets/images/Event-2025/Piece/icon-piece7-2.png";
import collect7_prize03 from "../../../../assets/images/Event-2025/Piece/icon-piece7-3.png";
import collect7_prize04 from "../../../../assets/images/Event-2025/Piece/icon-piece7-4.png";
import collect7_prize05 from "../../../../assets/images/Event-2025/Piece/icon-piece7-5.png";
import collect7_prize06 from "../../../../assets/images/Event-2025/Piece/icon-piece7-6.png";
import collect7_prize07 from "../../../../assets/images/Event-2025/Piece/icon-piece7-7.png";
import collect7_prize08 from "../../../../assets/images/Event-2025/Piece/icon-piece7-8.png";
import collect7_prize09 from "../../../../assets/images/Event-2025/Piece/icon-piece7-9.png";
import collect7_prize10 from "../../../../assets/images/Event-2025/Piece/icon-piece7-10.png";
import collect7_prize11 from "../../../../assets/images/Event-2025/Piece/icon-piece7-11.png";
import collect7_prize12 from "../../../../assets/images/Event-2025/Piece/icon-piece7-12.png";

// delete
import prizeSurface from "../../../../assets/images/Event-2025/prize-1.png";
import prizeHuawei from "../../../../assets/images/Event-2025/prize-2.png";
import prizeSpeaker from "../../../../assets/images/Event-2025/prize-3.png";
import prizeEarphone from "../../../../assets/images/Event-2025/prize-4.png";
import prizeMMK1 from "../../../../assets/images/Event-2025/prize-5.png";
import prizeMMK2 from "../../../../assets/images/Event-2025/prize-6.png";

export const ID_PRIZE = {
  prize_1: 1,
  prize_2: 2,
  prize_3: 3,
  prize_4: 4,
  prize_5: 5,
  prize_6: 6,
  prize_7: 7,
  prize_8: 8,
};

export const dataDetail = [
  {
    id: ID_PRIZE.prize_1,
    title: "5,000 MMK",
    srcImg: [
      { src: piece5mmk_01, name: "A", idPiece: 1 },
      { src: piece5mmk_02, name: "B", idPiece: 2 },
      { src: piece5mmk_03, name: "C", idPiece: 3 },
      { src: piece5mmk_04, name: "D", idPiece: 4 },
    ],
    quantityColumns: 2,
    srcDetailCollection: [
      { src: collect_prize01, name: "A", idPiece: 1 },
      { src: collect_prize02, name: "B", idPiece: 2 },
      { src: collect_prize03, name: "C", idPiece: 3 },
      { src: collect_prize04, name: "D", idPiece: 4 },
    ],
    fullImg: surface1,
  },
  {
    id: ID_PRIZE.prize_2,
    title: "10,000 MMK",
    srcImg: [
      { src: piece10mmk_01, name: "A", idPiece: 5 },
      { src: piece10mmk_02, name: "B", idPiece: 6 },
      { src: piece10mmk_03, name: "C", idPiece: 7 },
      { src: piece10mmk_04, name: "D", idPiece: 8 },
      { src: piece10mmk_05, name: "E", idPiece: 9 },
      { src: piece10mmk_06, name: "F", idPiece: 10 },
    ],
    srcDetailCollection: [
      { src: collect1_prize01, name: "A", idPiece: 5 },
      { src: collect1_prize02, name: "B", idPiece: 6 },
      { src: collect1_prize03, name: "C", idPiece: 7 },
      { src: collect1_prize04, name: "D", idPiece: 8 },
      { src: collect1_prize05, name: "E", idPiece: 9 },
      { src: collect1_prize06, name: "F", idPiece: 10 },
    ],
    quantityColumns: 3,
    fullImg: surface2,
  },
  {
    id: ID_PRIZE.prize_3,
    title: "20,000 MMK",
    srcImg: [
      { src: piece20mmk_01, name: "A", idPiece: 11 },
      { src: piece20mmk_02, name: "B", idPiece: 12 },
      { src: piece20mmk_03, name: "C", idPiece: 13 },
      { src: piece10mmk_04, name: "D", idPiece: 14 },
      { src: piece10mmk_05, name: "E", idPiece: 15 },
      { src: piece10mmk_06, name: "F", idPiece: 16 },
    ],
    srcDetailCollection: [
      { src: collect2_prize01, name: "A", idPiece: 11 },
      { src: collect2_prize02, name: "B", idPiece: 12 },
      { src: collect2_prize03, name: "C", idPiece: 13 },
      { src: collect2_prize04, name: "D", idPiece: 14 },
      { src: collect2_prize05, name: "E", idPiece: 15 },
      { src: collect2_prize06, name: "F", idPiece: 16 },
    ],
    quantityColumns: 3,
    fullImg: surface3,
  },
  {
    id: ID_PRIZE.prize_4,
    title: "50,000 MMK",
    srcImg: [
      { src: piece50mmk_01, name: "A", idPiece: 17 },
      { src: piece20mmk_02, name: "B", idPiece: 18 },
      { src: piece20mmk_03, name: "C", idPiece: 19 },
      { src: piece10mmk_04, name: "D", idPiece: 20 },
      { src: piece10mmk_05, name: "E", idPiece: 21 },
      { src: piece10mmk_06, name: "F", idPiece: 22 },
    ],
    srcDetailCollection: [
      { src: collect3_prize01, name: "A", idPiece: 17 },
      { src: collect3_prize02, name: "B", idPiece: 18 },
      { src: collect3_prize03, name: "C", idPiece: 19 },
      { src: collect3_prize04, name: "D", idPiece: 20 },
      { src: collect3_prize05, name: "E", idPiece: 21 },
      { src: collect3_prize06, name: "F", idPiece: 22 },
    ],
    quantityColumns: 3,
    fullImg: surface4,
  },
  {
    id: ID_PRIZE.prize_5,
    title: "Remax Voice Charger Earphone",
    srcImg: [
      { src: pieceTaiphone01, name: "A", idPiece: 23 },
      { src: pieceTaiphone02, name: "B", idPiece: 24 },
      { src: pieceTaiphone03, name: "C", idPiece: 25 },
      { src: pieceTaiphone04, name: "D", idPiece: 26 },
      { src: pieceTaiphone05, name: "E", idPiece: 27 },
      { src: pieceTaiphone06, name: "F", idPiece: 28 },
    ],
    srcDetailCollection: [
      { src: collect4_prize01, name: "A", idPiece: 23 },
      { src: collect4_prize02, name: "B", idPiece: 24 },
      { src: collect4_prize03, name: "C", idPiece: 25 },
      { src: collect4_prize04, name: "D", idPiece: 26 },
      { src: collect4_prize05, name: "E", idPiece: 27 },
      { src: collect4_prize06, name: "F", idPiece: 28 },
    ],
    quantityColumns: 3,
    fullImg: surface5,
  },

  {
    id: ID_PRIZE.prize_6,
    title: "ETO-S803 Bluetooth Speaker",
    srcImg: [
      { src: pieceLoa01, name: "A", idPiece: 29 },
      { src: pieceLoa02, name: "B", idPiece: 30 },
      { src: pieceLoa03, name: "C", idPiece: 31 },
      { src: pieceLoa04, name: "D", idPiece: 32 },
      { src: pieceLoa05, name: "E", idPiece: 33 },
      { src: pieceLoa06, name: "F", idPiece: 34 },
      { src: pieceLoa07, name: "G", idPiece: 35 },
      { src: pieceLoa08, name: "H", idPiece: 36 },
      { src: pieceLoa09, name: "I", idPiece: 37 },
    ],
    srcDetailCollection: [
      { src: collect5_prize01, name: "A", idPiece: 29 },
      { src: collect5_prize02, name: "B", idPiece: 30 },
      { src: collect5_prize03, name: "C", idPiece: 31 },
      { src: collect5_prize04, name: "D", idPiece: 32 },
      { src: collect5_prize05, name: "E", idPiece: 33 },
      { src: collect5_prize06, name: "F", idPiece: 34 },
      { src: collect5_prize07, name: "G", idPiece: 35 },
      { src: collect5_prize08, name: "H", idPiece: 36 },
      { src: collect5_prize09, name: "I", idPiece: 37 },
    ],
    fullImg: surface6,
  },
  {
    id: ID_PRIZE.prize_7,
    title: "Huawei Band 9",
    srcImg: [
      { src: pieceSmartWatch01, name: "A", idPiece: 38 },
      { src: pieceSmartWatch02, name: "B", idPiece: 39 },
      { src: pieceSmartWatch03, name: "C", idPiece: 40 },
      { src: pieceSmartWatch04, name: "D", idPiece: 41 },
      { src: pieceSmartWatch05, name: "E", idPiece: 42 },
      { src: pieceSmartWatch06, name: "F", idPiece: 43 },
      { src: pieceSmartWatch07, name: "G", idPiece: 44 },
      { src: pieceSmartWatch08, name: "H", idPiece: 45 },
      { src: pieceSmartWatch09, name: "I", idPiece: 46 },
    ],
    srcDetailCollection: [
      { src: collect6_prize01, name: "A", idPiece: 38 },
      { src: collect6_prize02, name: "B", idPiece: 39 },
      { src: collect6_prize03, name: "C", idPiece: 40 },
      { src: collect6_prize04, name: "D", idPiece: 41 },
      { src: collect6_prize05, name: "E", idPiece: 42 },
      { src: collect6_prize06, name: "F", idPiece: 43 },
      { src: collect6_prize07, name: "G", idPiece: 44 },
      { src: collect6_prize08, name: "H", idPiece: 45 },
      { src: collect6_prize09, name: "I", idPiece: 46 },
    ],
    fullImg: surface7,
  },

  {
    id: ID_PRIZE.prize_8,
    title: "Microsoft Surface Pro 9",
    srcImg: [
      { src: pieceIpad01, name: "A", idPiece: 47 },
      { src: pieceIpad02, name: "B", idPiece: 48 },
      { src: pieceIpad03, name: "C", idPiece: 49 },
      { src: pieceIpad04, name: "D", idPiece: 50 },
      { src: pieceIpad05, name: "E", idPiece: 51 },
      { src: pieceIpad06, name: "F", idPiece: 52 },
      { src: pieceIpad07, name: "G", idPiece: 53 },
      { src: pieceIpad08, name: "H", idPiece: 54 },
      { src: pieceIpad09, name: "I", idPiece: 55 },
      { src: pieceIpad10, name: "J", idPiece: 56 },
      { src: pieceIpad11, name: "K", idPiece: 57 },
      { src: pieceIpad12, name: "L", idPiece: 58 },
    ],
    srcDetailCollection: [
      { src: collect7_prize01, name: "A", idPiece: 47 },
      { src: collect7_prize02, name: "B", idPiece: 48 },
      { src: collect7_prize03, name: "C", idPiece: 49 },
      { src: collect7_prize04, name: "D", idPiece: 50 },
      { src: collect7_prize05, name: "E", idPiece: 51 },
      { src: collect7_prize06, name: "F", idPiece: 52 },
      { src: collect7_prize07, name: "G", idPiece: 53 },
      { src: collect7_prize08, name: "H", idPiece: 54 },
      { src: collect7_prize09, name: "I", idPiece: 55 },
      { src: collect7_prize10, name: "J", idPiece: 56 },
      { src: collect7_prize11, name: "K", idPiece: 57 },
      { src: collect7_prize12, name: "L", idPiece: 58 },
    ],
    fullImg: surface8,
  },
];

export const dataListProduct = [
  {
    id: ID_PRIZE.prize_8,
    title: "Microsoft Surface Pro 9",
    srcImg: prize8,
    content: "Microsoft Surface Pro 9",
    totalPiece: 12,
  },
  {
    id: ID_PRIZE.prize_7,
    title: "Huawei Band 9",
    srcImg: prize7,
    content: "Huawei Band 9",
    totalPiece: 9,
  },
  {
    id: ID_PRIZE.prize_6,
    title: "ETO-S803 Bluetooth Speaker",
    srcImg: prize6,
    content: "ETO-S803 Bluetooth Speaker",
    totalPiece: 9,
  },
  {
    id: ID_PRIZE.prize_5,
    title: "Remax Voice Charger Earphone",
    srcImg: prize5,
    content: "Remax Voice Charger Earphone",
    totalPiece: 6,
  },
  {
    id: ID_PRIZE.prize_4,
    title: "50,000 MMK",
    srcImg: prize4,
    content: "50,000 MMK",
    totalPiece: 6,
  },
  {
    id: ID_PRIZE.prize_3,
    title: "20,000 MMK",
    srcImg: prize3,
    content: "20,000 MMK",
    totalPiece: 6,
  },
  {
    id: ID_PRIZE.prize_2,
    title: "10,000 MMK",
    srcImg: prize2,
    content: "10,000 MMK",
    totalPiece: 6,
  },
  {
    id: ID_PRIZE.prize_1,
    title: "5,000 MMK",
    srcImg: prize1,
    content: "5,000 MMK",
    totalPiece: 4,
  },
];

// delete
export const DefineDataPopupWinner = [
  {
    key: 1,
    image: {
      img: prizeSurface,
      name: "Mircosoft Surface Pro 9",
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx891",
  },
  {
    key: 2,
    image: {
      img: prizeHuawei,
      name: "Huawei Band 9",
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx899",
  },
  {
    key: 3,
    image: {
      img: prizeSpeaker,
      name: "ETO-S803 Bluettoth Speaker",
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx899",
  },
  {
    key: 4,
    image: {
      img: prizeEarphone,
      name: "Remax Voice Charger Earphone",
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx899",
  },
  {
    key: 5,
    image: {
      img: prizeMMK1,
      // name: "Mircosoft Surface Pro 9"
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx899",
  },
  {
    key: 6,
    image: {
      img: prizeMMK2,
      // name: "Mircosoft Surface Pro 9"
    },
    time: "06/02/2025 14:30:23",
    isdn: "099xxxxx899",
  },
];

export const idPrize = {
  goodluck: 1,
  prize: 3, //mảnh ghép
  coin: 4, //lượt quay
  feeBid: 2,
};
